export default __webpack_public_path__ + "media/images/react_icons/phone-b02212f98ab4537dfc42810c91506f3e.svg";